const _ = require('lodash');

module.exports = function (eventName) {
    return {
        event: {
            eventName,
            _hash: _.random(0, Number.MAX_VALUE).toString(36),
        },
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/analytics/dtm/common-mappers/event-analytics-mapper.js